import { createContext, useContext } from 'react'

export type Theme = 'dark' | 'light' | 'system' | 'custom'

type ThemeProviderState = {
	theme: Theme
}

const initialState: ThemeProviderState = {
	theme: 'dark',
}

// Component-free module keeps this context's identity stable across Fast Refresh;
// co-locating it with a component export makes HMR mint a new context and desync the provider.
export const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export const useTheme = () => {
	const context = useContext(ThemeProviderContext)

	if (context === undefined) {
		throw new Error('useTheme must be used within a ThemeProvider')
	}

	return context
}
